import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';

@Component({
  selector: 'app-column-brand',
  templateUrl: './column-brand.component.html',
  styleUrls: ['./column-brand.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnBrandComponent extends ColumnComponent {
  @Input() useNgContent: boolean;
}
